<!-- banner管理 banner-->
<template>
  <div class="banner">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="80px">
        <div class="form_list">
          <el-form-item label="状态：">
            <el-select v-model="userform.status" placeholder="请选择状态">
              <el-option label="停用" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="nomode">取消</el-button>
          </div>
        </div>
      </el-form>
      <div>
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player> -->
    <div class="user_list">
      <el-table :data="bannerList" style="width: 100%" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="pc_img" label="PC图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.pc_img" :preview-src-list="scope.row.PCsrcList"></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="pc_img" label="PC视频">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.pc_img" :preview-src-list="scope.row.PCsrcList"></el-image>
          </template>
        </el-table-column>-->
        <el-table-column prop="h5_img" label="APP图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.h5_img" :preview-src-list="scope.row.APPsrcList"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">停用</span>
            <span v-if="scope.row.status==1">正常</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="seede(scope.row)" type="text" size="small">查看</el-button>
            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button @click="removesize(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="editStatus(scope.row)" type="text" size="small">
              <span v-if="scope.row.status==0">启用</span>
              <span v-if="scope.row.status==1">停用</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 查看视频弹窗 -->
    <el-dialog title="详情" :visible.sync="videoup" @close="cancelform">
      <!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="newplayerOptions"></video-player> -->
      <el-form :model="TWOEdform" :rules="rules" label-width="100px">
        <el-form-item label="标题">
          <div>{{TWOEdform.title}}</div>
        </el-form-item>
        <el-form-item label="内容">
          <div>{{TWOEdform.content}}</div>
        </el-form-item>
        <el-form-item label="按钮内容">
          <div>{{TWOEdform.btnText}}</div>
        </el-form-item>
        <el-form-item label="PC图片">
          <img style="width:50%;" :src="TWOEdform.fileList1[0].url" alt />
        </el-form-item>
        <el-form-item label="PC视频" v-if="playerOptions.sources[0].src !==''">
          <!-- <el-input v-model="Edform.pc_img"></el-input> -->
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
        </el-form-item>
        <el-form-item label="APP图片">
          <img style="width:50%;max-height:300px" :src="TWOEdform.fileList2[0].url" alt />
        </el-form-item>
        <el-form-item label="APP视频" v-if="playerOptions.sources[0].src !==''">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptionsTwo"></video-player>
        </el-form-item>
        <el-form-item label="状态：">
          <span v-if="TWOEdform.status==0">停用</span>
          <span v-if="TWOEdform.status==1">正常</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="Edform.title"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="Edform.content"></el-input>
        </el-form-item>
        <el-form-item label="按钮内容">
          <el-input v-model="Edform.btnText"></el-input>
        </el-form-item>
        <el-form-item label="PC图片">
          <!-- <el-input v-model="Edform.pc_img"></el-input> -->
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,1)" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList1" :class="{ hideUpload: Edform.fileList1.length > 0 }" :on-remove="(file)=>handleRemove(file,1)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="PC视频">
          <!-- <el-input v-model="Edform.pc_img"></el-input> -->
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,3)" accept=".mp4" :limit="1" :file-list="Edform.fileList3" :class="{ hideUploads: Edform.fileList3.length > 0 }" :on-remove="(file)=>handleRemove(file,3)">
            <div slot="file" slot-scope="{file}">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
              <span class="vide_sc" @click="handleRemove(file,3)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="APP图片">
          <!-- <el-input v-model="Edform.h5_img"></el-input> -->
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,2)" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList2" :class="{ hideUpload: Edform.fileList2.length > 0 }" :on-remove="(file)=>handleRemove(file,2)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="APP视频">
          <!-- <el-input v-model="Edform.pc_img"></el-input> -->
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,4)" accept=".mp4" :limit="1" :file-list="Edform.fileList4" :class="{ hideUploads: Edform.fileList4.length > 0 }" :on-remove="(file)=>handleRemove(file,4)">
            <div slot="file" slot-scope="{file}">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptionsTwo"></video-player>
              <span class="vide_sc" @click="handleRemove(file,4)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="Edform.status" placeholder="请选择状态">
            <el-option label="停用" value="0"></el-option>
            <el-option label="正常" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转页面：">
          <el-select v-model="Edform.links" placeholder="请选择跳转页面">
            <el-option label="积分领取" value="/modular/integral"></el-option>
            <el-option label="礼品兑换" value="/gift"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  bannerlists,
  banneradd,
  bannereditStatus,
  bannerdelete,
  banneredit
} from "../../api/system.js";
import { uploadimg, hostimg } from "../../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        status: ""
      },
      TWOEdform: {
        title: "",
        content: "",
        btnText: "",
        status: "",
        fileList1: [
          {
            url: ""
          }
        ],
        fileList2: [
          {
            url: ""
          }
        ],
        fileList3: [],
        fileList4: []
      },
      Edform: {
        title: "",
        content: "",
        btnText: "",
        status: "",
        links: "",
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: []
      },
      bannerList: [
        {
          name: "9f30002",
          num: "1000",
          name1: "启用"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      domainUrl: "",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src:
              "https://hansun.oss-cn-hangzhou.aliyuncs.com/qianduan2021/video/8.mp4" // url地址
          }
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      playerOptionsTwo: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src:
              "https://hansun.oss-cn-hangzhou.aliyuncs.com/qianduan2021/video/8.mp4" // url地址
          }
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      newplayerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src:
              "https://hansun.oss-cn-hangzhou.aliyuncs.com/qianduan2021/video/8.mp4" // url地址
          }
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      videoup: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log("实时域名", res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.bannerdata();
        }
      });
    },

    //banner列表
    bannerdata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        status: this.userform.status,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      bannerlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          res.data.data.forEach((ele, i) => {
            res.data.data[i].PCsrcList = [];
            res.data.data[i].PCsrcList.push(this.domainUrl + ele.pc_img);
            res.data.data[i].APPsrcList = [];
            res.data.data[i].APPsrcList.push(this.domainUrl + ele.h5_img);
          });
          this.bannerList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.bannerdata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.bannerdata();
    },
    //取消搜索
    nomode() {
      this.userform.status = "";
      this.currentindex = 1;
      this.bannerdata();
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
      this.Edform.fileList1 = [];
      this.Edform.fileList2 = [];
      this.Edform.fileList3 = [];
      this.Edform.fileList4 = [];
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
      this.Edform.fileList1 = [];
      this.Edform.fileList2 = [];
      this.Edform.id = e.id;
      this.Edform.title = e.title;
      this.Edform.content = e.content;
      this.Edform.btnText = e.btnText;
      this.Edform.links = e.links;
      this.Edform.status = String(e.status);
      this.Edform.fileList1.push({
        url: this.domainUrl + e.pc_img,
        path: e.pc_img,
        name: "PC图片"
      });
      this.Edform.fileList2.push({
        url: this.domainUrl + e.h5_img,
        path: e.h5_img,
        name: "H5图片"
      });
      if (e.video1 !== "") {
        this.Edform.fileList3.push({
          url: this.domainUrl + e.video1,
          path: e.video1,
          name: "PC视频"
        });
        this.playerOptions.sources[0].src = this.domainUrl + e.video1;
      } else {
        this.Edform.fileList3 = [];
        this.playerOptions.sources[0].src = "";
      }
      if (e.video2 !== "") {
        this.Edform.fileList4.push({
          url: this.domainUrl + e.video2,
          path: e.video2,
          name: "APP视频"
        });
        this.playerOptionsTwo.sources[0].src = this.domainUrl + e.video2;
      } else {
        this.Edform.fileList4 = [];
        this.playerOptionsTwo.sources[0].src = "";
      }
    },
    //PC图片上传
    handaddimg(file, i) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      uploadimg(form).then(res => {
        // console.log(res);
        // console.log(this.Edform.fileList);
        if (res.status_code == 200) {
          //PC图片
          if (i == 1) {
            this.Edform.fileList1.push({
              name: res.data.original_name,
              url: res.data.url,
              path: res.data.path
            });
          }
          // APP图片？
          if (i == 2) {
            this.Edform.fileList2.push({
              name: res.data.original_name,
              url: res.data.url,
              path: res.data.path
            });
          }
          // PC视频
          if (i == 3) {
            this.playerOptions.sources[0].src = res.data.url;
            this.Edform.fileList3.push({
              name: res.data.original_name,
              url: res.data.url,
              path: res.data.path
            });
          }
          // APP视频
          if (i == 4) {
            this.playerOptionsTwo.sources[0].src = res.data.url;
            this.Edform.fileList4.push({
              name: res.data.original_name,
              url: res.data.url,
              path: res.data.path
            });
          }
        }
      });
    },
    //PC删除上传
    handleRemove(file, i) {
      // console.log(file);
      //PC图片
      if (i == 1) {
        this.Edform.fileList1 = [];
      }
      // APP图片？
      if (i == 2) {
        this.Edform.fileList2 = [];
      }
      // PC视频
      if (i == 3) {
        this.Edform.fileList3 = [];
      }
      // APP视频
      if (i == 4) {
        this.Edform.fileList4 = [];
      }
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.Edform.fileList3.length == 0) {
        this.Edform.fileList3 = [];
      }
      if (this.Edform.fileList4.length == 0) {
        this.Edform.fileList4 = [];
      }

      if (this.titleName == "新增") {
        if (this.Edform.fileList1.length == 0) {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.fileList2.length == 0) {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.title == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.status == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.content == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.btnText == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.links == "") {
          this.$message({
            type: "warning",
            message: "请选择跳转地址!"
          });
        } else {
          let data = {
            pc_img: this.Edform.fileList1[0].path,
            h5_img: this.Edform.fileList2[0].path,
            title: this.Edform.title,
            content: this.Edform.content,
            btnText: this.Edform.btnText,
            status: this.Edform.status,
            links: this.Edform.links,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          if (this.Edform.fileList3.length > 0) {
            data.video1 = this.Edform.fileList3[0].path;
          } else {
            data.video1 = "";
          }
          if (this.Edform.fileList4.length !== 0) {
            data.video2 = this.Edform.fileList4[0].path;
          } else {
            data.video2 = "";
          }
          banneradd(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.userform.status = "";
              this.currentindex = 1;
              this.bannerdata();
              this.$message({
                type: "success",
                message: "Success!"
              });
            }
          });
        }
      } else {
        if (this.Edform.fileList1.length == 0) {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.fileList2.length == 0) {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.title == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.status == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.content == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.btnText == "") {
          this.$message({
            type: "warning",
            message: "请将基础信息填写完整!"
          });
        } else if (this.Edform.links == "") {
          this.$message({
            type: "warning",
            message: "请选择跳转地址!"
          });
        } else {
          let data = {
            id: this.Edform.id,
            pc_img: this.Edform.fileList1[0].path || "",
            h5_img: this.Edform.fileList2[0].path || "",
            title: this.Edform.title,
            content: this.Edform.content,
            btnText: this.Edform.btnText,
            status: this.Edform.status,
            links: this.Edform.links,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          if (this.Edform.fileList3.length > 0) {
            data.video1 = this.Edform.fileList3[0].path;
          } else {
            data.video1 = "";
          }
          if (this.Edform.fileList4.length > 0) {
            data.video2 = this.Edform.fileList4[0].path;
          } else {
            data.video2 = "";
          }
          banneredit(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.userform.status = "";
              this.currentindex = 1;
              this.bannerdata();
              this.$message({
                type: "success",
                message: "编辑成功!"
              });
            }
          });
        }
      }
    },
    //弹窗取消
    cancelform() {
      this.videoup = false;
      this.pop_up = false;
      this.Edform.title = "";
      this.Edform.links = "";
      this.Edform.content = "";
      this.Edform.btnText = "";
      this.Edform.status = "";
      this.Edform.fileList1 = [
        {
          url: ""
        }
      ];
      this.Edform.fileList2 = [
        {
          url: ""
        }
      ];
      this.Edform.fileList3 = [];
      this.Edform.fileList4 = [];
    },
    //查看
    seede(e) {
      // console.log(e);
      this.videoup = true;
      this.TWOEdform.fileList1 = [];
      this.TWOEdform.fileList2 = [];
      this.TWOEdform.title = e.title;
      this.TWOEdform.content = e.content;
      this.TWOEdform.btnText = e.btnText;
      this.TWOEdform.status = String(e.status);
      this.TWOEdform.fileList1.push({
        url: this.domainUrl + e.pc_img,
        path: e.pc_img,
        name: "PC图片"
      });
      this.TWOEdform.fileList2.push({
        url: this.domainUrl + e.h5_img,
        path: e.h5_img,
        name: "H5图片"
      });
      if (e.video1 !== "") {
        this.playerOptions.sources[0].src = this.domainUrl + e.video1;
      } else {
        this.playerOptions.sources[0].src = "";
      }
      if (e.video2 !== "") {
        this.playerOptionsTwo.sources[0].src = this.domainUrl + e.video2;
      } else {
        this.playerOptionsTwo.sources[0].src = "";
      }
      // console.log(this.playerOptions.sources[0].src);
      // console.log(this.playerOptionsTwo.sources[0].src);
    },
    //状态改变
    editStatus(e) {
      let data;
      if (e.status == 0) {
        data = {
          id: e.id,
          status: 1
        };
      } else {
        data = {
          id: e.id,
          status: 0
        };
      }
      bannereditStatus(data).then(res => {
        if (res.status_code == 200) {
          this.userform.status = "";
          this.currentindex = 1;
          this.bannerdata();
          this.$message({
            type: "success",
            message: "修改成功!"
          });
        }
      });
    },
    //删除
    removesize(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      bannerdelete(data).then(res => {
        if (res.status_code == 200) {
          this.userform.status = "";
          this.currentindex = 1;
          this.bannerdata();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.domainName();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.banner {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.banner {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
.hideUpload {
  .el-upload.el-upload--picture-card {
    display: none !important;
  }
}
.hideUploads {
  .vide_sc {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 400px;
    height: 225px;
  }
  .el-upload.el-upload--picture-card {
    display: none !important;
  }
}
</style>